import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { camelize } from 'src/utils/helpers'

import getSvgIcons from './getSvgIcons'

import styles from './styles.module.less'

class SvgIcon extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xlg']),
  }

  static defaultProps = {
    type: 'CheckedNo',
    size: 'sm',
  }

  render() {
    const { type, size, addClassName, ...rest } = this.props
    const icons = getSvgIcons()
    const Icon = icons[camelize(type)]
    if (!Icon) {
      return null
    }

    const classNames = classnames({
      [styles.icon]: true,
      [styles[size]]: true,
      'svg-icon': true,
      [addClassName]: !!addClassName,
    })

    return <Icon data-cy={type} className={classNames} {...rest} />
  }
}

export default SvgIcon
